export function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] ?? c);
}
export const BASE_CSS = `
@page { size: A4; margin: 16mm 14mm 18mm 14mm; }
:root { --primary: #2F2F76; --accent: #009640; --ink: #1F2233; --ink2: #5B5F73; --line: #D9DAEA; --zebra: #F3F3FD; }
* { box-sizing: border-box; }
body { margin: 0; font: 10.5pt/1.45 "IBM Plex Sans", "Noto Naskh Arabic", Arial, sans-serif; color: var(--ink); }
.doc-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12mm; border-bottom: 2px solid var(--primary); padding-bottom: 4mm; }
.doc-header img { max-height: 22mm; max-width: 60mm; }
.entity { font-size: 8.5pt; color: var(--ink2); }
.entity b { color: var(--primary); font-size: 11pt; display: block; }
.doc-title { margin: 8mm 0 2mm; font: 700 16pt/1.1 "Manrope", "Noto Kufi Arabic", sans-serif; color: var(--primary); }
.doc-title small { display: block; font-size: 9pt; font-weight: 500; color: var(--accent); margin-top: 1mm; letter-spacing: .08em; }
.doc-ref { font: 9pt "IBM Plex Mono", monospace; color: var(--ink2); }
table.data { width: 100%; border-collapse: collapse; margin: 4mm 0; font-size: 9.5pt; }
table.data th { background: var(--primary); color: #fff; text-align: left; padding: 2mm 2.5mm; font-weight: 600; }
table.data td { padding: 1.8mm 2.5mm; border-bottom: 1px solid var(--line); vertical-align: top; }
table.data tr:nth-child(even) td { background: var(--zebra); }
.num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.bilingual { display: grid; grid-template-columns: 1fr 1fr; gap: 6mm; }
.rtl { direction: rtl; text-align: right; font-family: "Noto Naskh Arabic", "IBM Plex Sans", sans-serif; }
.signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 10mm; margin-top: 12mm; }
.signatures div { border-top: 1px solid var(--line); padding-top: 2mm; font-size: 9pt; color: var(--ink2); min-height: 28mm; }
.doc-footer { position: fixed; bottom: 0; left: 0; right: 0; font-size: 8pt; color: var(--ink2); display: flex; justify-content: space-between; border-top: 1px solid var(--line); padding-top: 1.5mm; }
`;
export function renderDocument(entity, meta, bodyHtml) {
    const primary = entity.primaryColor ?? "#2F2F76";
    const accent = entity.accentColor ?? "#009640";
    const rtl = meta.lang === "ar";
    const idLine = [
        entity.rc && `RC ${escapeHtml(entity.rc)}`,
        entity.nif && `NIF ${escapeHtml(entity.nif)}`,
        entity.nis && `NIS ${escapeHtml(entity.nis)}`,
        entity.ai && `AI ${escapeHtml(entity.ai)}`,
    ]
        .filter(Boolean)
        .join(" · ");
    return `<!doctype html>
<html lang="${rtl ? "ar" : "fr"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><title>${escapeHtml(meta.title)} — ${escapeHtml(meta.reference)}</title>
<style>${BASE_CSS} :root{--primary:${primary};--accent:${accent};}</style></head>
<body>
<header class="doc-header">
  <div class="entity">
    <b>${escapeHtml(entity.legalNameFr)}</b>
    ${entity.legalNameAr ? `<span class="rtl">${escapeHtml(entity.legalNameAr)}</span><br>` : ""}
    ${entity.activityFr ? `${escapeHtml(entity.activityFr)}<br>` : ""}
    ${idLine ? `${idLine}<br>` : ""}
    ${[entity.address, entity.phone, entity.email].filter(Boolean).map((x) => escapeHtml(x)).join(" · ")}
  </div>
  ${entity.logoDataUri ? `<img src="${entity.logoDataUri}" alt="">` : ""}
</header>
<h1 class="doc-title">${escapeHtml(meta.title)}${meta.titleAr ? `<small class="rtl">${escapeHtml(meta.titleAr)}</small>` : ""}</h1>
<div class="doc-ref">${escapeHtml(meta.reference)} · ${escapeHtml(meta.date)}</div>
<main>${bodyHtml}</main>
<footer class="doc-footer"><span>${escapeHtml(entity.legalNameFr)} — ${escapeHtml(meta.title)}</span><span>${escapeHtml(meta.reference)}</span></footer>
</body></html>`;
}
//# sourceMappingURL=layout.js.map